<template>
  <div v-click-outside="close" class="form-item">
    <span v-if="title" class="form-item__title">{{ title }}</span>
    <div v-click-outside="close" class="form-item__block">
      <div class="width-100 position-relative">
        <Input
          v-model="search"
          class="width-100 form-item__input -input-only-"
          placeholder="Поиск пользователей"
          :error="errorSearch && '*Пользователь не найден'"
          input-class="padding-left-30"
        ></Input>
        <Icon
          class="search__main-icon position-absolute margin-left__10 svg-top__50-12"
          icon="search-thin"
        ></Icon>
      </div>
      <SlideUpDown
        v-if="isOpen"
        class="select__slider"
        :duration="slideDuration"
        :style="styles"
        :active="isOpen"
      >
        <div class="select__field -no-padding-">
          <div
            v-for="(item, idx) in data"
            :key="idx"
            class="select__item justify-start"
            @click="setOption(item)"
          >
            <template v-if="item">
              <Avatar circle="circle" size="s" :img="item.avatar"></Avatar>
              <p class="select__text">{{ item.name }} {{ item.lastname }}</p>
              <p class="select__text">{{ item.email }}</p>
            </template>
          </div>
        </div>
      </SlideUpDown>
    </div>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import { mapActions, mapState } from 'vuex';

export default {
  directives: { clickOutside: vClickOutside.directive },
  components: { SlideUpDown },
  props: ['value', 'title', 'error', 'selectData', 'groupId'],
  data: () => ({
    search: '',
    userId: '',
    isOpen: false,
    list: '',
    isChoosing: false,
    slideDuration: 200,
    errorSearch: false
  }),
  computed: {
    ...mapState('usersTeamMembers', {
      users: s => s.aside.data.users
    }),
    styles() {
      if (this.users.length > 0) {
        return { display: 'block' };
      } else {
        return { display: 'none' };
      }
    },
    data() {
      if (Array.isArray(this.users)) {
        return this.users.filter(el => !this.team.includes(el.id));
      }
      return undefined;
    },
    team() {
      return this.selectData.map(el => el.id);
    }
  },
  watch: {
    users(val) {
      this.errorSearch = val && val.length === 0 && this.search && this.search.length > 0;
    },
    search(val) {
      if (val.length > 0) {
        this.isOpen = true;
        this.searchMethods({ name: val, id: this.groupId });
      } else {
        this.errorSearch = false;
        this.close();
      }
    }
  },
  methods: {
    ...mapActions('usersTeamMembers', ['searchMethods']),
    close() {
      this.isOpen = false;
      this.$store.dispatch('users/setData', { path: 'users', value: '' });
    },
    setOption(item) {
      const obj = {
        isNew: true,
        id: item.id,
        avatar: item.avatar,
        email: item.email,
        name: item.name,
        lastname: item.lastname,
        isLeader: false,
        isCaptain: false,
        isDelete: false
      };
      this.$emit('input', obj);
      this.search = '';
      this.close();
    }
  }
};
</script>
